require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-craftsmen-barbershop-grand-opening.json") })
        }
      }, "path---news-craftsmen-barbershop-grand-opening");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-craftsmen-barbershop-grand-opening!./.cache/json/news-craftsmen-barbershop-grand-opening.json
// module id = 804
// module chunks = 231608221292675